import { User } from 'types/User'

type State = {
  user: User
}

export const getUser = (state: State): User => state.user || {}
export const getUserOrNull = (state: State): User | null => state.user || null
